import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { NavLink } from 'react-router-dom';
import NextButton from './components/NextButton';
import PaymentMethodCard from './components/PaymentMethodCard';


const PaymentMethodPage = ({ selectedPaymentMethod, onSelect, paypalEmail, venmoUsername, onPaypalEmailChange, onVenmoUsernameChange, paypalEmailError, venmoUsernameError, onPaypalEmailErrorChange, onVenmoUsernameErrorChange, venmoUsernameRef, paypalEmailRef, paymentMethodRef, agreementCheckedError, formComplete, onSubmit, hidePaymentMethod, paymentMethodPageStyle }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    // onSubmit validates and returns true only when the submit actually fired.
    const ok = onSubmit(e);
    if (ok) {
      setIsLoading(true);
    }
  }

  if (!hidePaymentMethod) {
      return (
        <div className="checkout-page" style={paymentMethodPageStyle}>
          <Grid>
              <Typography ref={paymentMethodRef} gutterBottom variant="h5">
                  Select Payment Method
              </Typography>
              <Grid container spacing={2}>
                <Grid xs={12} sm={4} item>
                  <PaymentMethodCard method="PayPal" description="Receive PayPal payment upon delivery." onSelect={onSelect} selected={selectedPaymentMethod == "PayPal"} />
                </Grid>
                <Grid xs={12} sm={4} item>
                  <PaymentMethodCard method="Venmo" description="Receive Venmo payment upon delivery." onSelect={onSelect} selected={selectedPaymentMethod == "Venmo"} />
                </Grid>
                <Grid xs={12} sm={4} item>
                  <PaymentMethodCard method="Check" description="Check in the mail upon delivery." onSelect={onSelect} selected={selectedPaymentMethod == "Check"} />
                </Grid>
                {
                  selectedPaymentMethod == "PayPal" &&
                  <Grid xs={12} sm={12} item style={{ marginTop: "24px" }}>
                    <TextField inputRef={paypalEmailRef} name="paypalEmail" autoComplete="off" label="PayPal Email" placeholder="Enter PayPal email" variant="outlined" fullWidth required value={paypalEmail} onChange={onPaypalEmailChange} error={paypalEmailError} />
                    <Typography variant="caption" color="textSecondary" component="p" style={{ marginTop: "8px" }}>
                      Please note, PayPal Business accounts can only receive Goods &amp; Services payments, which incur a 3% fee and may be reported for federal tax purposes.
                    </Typography>
                  </Grid>
                }
                {
                  selectedPaymentMethod == "Venmo" &&
                  <Grid xs={12} sm={12} item style={{ marginTop: "24px" }}>
                    <TextField inputRef={venmoUsernameRef} name="venmoUsername" autoComplete="off" label="Venmo Username" placeholder="Enter Venmo Username" variant="outlined" fullWidth required value={venmoUsername} onChange={onVenmoUsernameChange} error={venmoUsernameError} />
                  </Grid>
                }
                <Grid item xs={12} style={{ marginTop: "24px" }}>
                    <NextButton className="submit-button" fullWidth title="Submit" isLoading={isLoading} isDisabled={!formComplete} onClick={handleSubmit} />
                </Grid>
              </Grid>
          </Grid>
        </div>
      );
    } else {
      return (
        <div className="checkout-page">
          <Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ marginTop: "24px" }}>
                    <NextButton className="submit-button" fullWidth title="Submit" isLoading={isLoading} isDisabled={!formComplete} onClick={handleSubmit} />
                </Grid>
              </Grid>
          </Grid>
        </div>
      )
    }
}

export default PaymentMethodPage;
